import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addProvider } from '../../../../actions/providers';
import Row from '../../../../components/Basic/Blocks/Row';
import Button from '../../../../components/Basic/Buttons/Button';
import H2 from '../../../../components/Basic/WrapsStyle/H/H2';
import { TYPE_BUTTONS } from '../../../../constans';

import ProviderInfoApi from '../../../../API/provider/providerInfo-api';
import PopUp from '../../../../components/Basic/Blocks/PopUp';
import CheckButton from '../../../../components/Basic/Buttons/Check';
import Input from '../../../../components/Basic/Inputs/Base';
import Text from '../../../../components/Basic/WrapsStyle/Text';
import styles from './styles.module.scss';

const CreateProviderPopUp = ({ close = () => { } }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    name: '',
    prefix: '',
    id: '',
    is_stock: false,
  });

  const [valid, setValid] = useState({
    name: '',
  });

  const disabled_button = !data.name.length > 0;

  const validate = () => {
    if (!disabled_button) {
      return true;
    } else {
      setValid({
        name: data.name.length > 0 ? '' : 'Заполни поле ',
      });
      return false;
    }
  };

  const clickAdd = () => {
    if (validate()) {
      ProviderInfoApi.addProvider({
        data: {
          ...data,
          id: parseInt(data.id)
        }
      }).then((r) => dispatch(addProvider(r.provider)));
      close();
    }
  };

  useEffect(() => {
    setValid({ name: '' });
  }, [data.name]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Добавить нового поставщика</H2>
      <Input
        value={data.name}
        label="Имя"
        width="80%"
        error={valid.name}
        onChange={(v) => setData({ ...data, name: v })}
      />
      {/*        <Input
            value={data.name}
            label="Имя на латинице"
            width="80%"
            error={valid.name}
            onChange={(v) => setData({ ...data, name: v })}
        />*/}
      <Row>
        <Input
          value={data.prefix}
          label="Префикс"
          onChange={(v) => setData({ ...data, prefix: v })}
          width={'120px'}
          style={{ marginRight: '15px' }}
        />
        <Input
          value={data.id}
          label="Уникальный номер"
          width={'160px'}
          style={{ marginRight: '15px' }}
          onChange={(v) => setData({ ...data, id: v })}
        />
      </Row>

      <Row style={{ marginTop: "10px" }}>
        <CheckButton
          checked={data.is_stock}
          onSelect={(v) => setData({ ...data, is_stock: v })}
          style={{ marginRight: '15px' }}
        />
        <Text>Мелкий поставщик</Text>
      </Row>

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={disabled_button}
          style={{ marginRight: '15px' }}
          onClick={disabled_button ? () => { } : clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CreateProviderPopUp;
